import { loginDestination } from "@/lib/adminNavigation";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useI18n } from "@/contexts/LanguageContext";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isChecking } = useAuth();
  const location = useLocation();
  const { t } = useI18n();

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="nvl-overline text-[color:hsl(var(--nvl-ink-soft))]">{t("common.loading")}</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}

export function PublicOnlyRoute({ children }) {
  const { user, isAuthenticated, isChecking } = useAuth();
  const location = useLocation();
  if (isChecking) return null;
  if (isAuthenticated) return <Navigate to={loginDestination(user, location.state?.from)} replace />;
  return children;
}
